(function(){
    angular
        .module('appback')
        .directive('ngNuevalectura', nuevaLectura);

        nuevaLectura.$inject = ['socket','GenerallabService','MicrobiologiaService','ResultadosService','$timeout', 'Upload', '$uibModal'];
        function nuevaLectura(socket,GenerallabService,MicrobiologiaService,ResultadosService,$timeout, Upload, $uibModal){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=nuevalectura.twig',
		          scope: {
                    lc: '=',
                    paisid: '=',
                    peticionid: '=',
                    analiticaid: '=',
                    resembradoid: '=',
                    medios: '=',
                    microaislado: '=',
                    editarlec: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        console.log("scope nueva lectura inicial", scope);
                        scope.generalLab = GenerallabService;
                        scope.data = {bloques_medios_condiciones: []};
                        scope.contNextAntibiogramaMalditofID = 1;
                        scope.isNuevaLecturaOpen = false;

                        scope.toggleNuevaLectura = function(){
                            scope.isNuevaLecturaOpen = !scope.isNuevaLecturaOpen;
                        }

                        scope.newMedioCond = function(){
                            ResultadosService.getMediosCondiciones(scope.analiticaid,scope.paisid,function(data){
                                var medioscondiciones = [];
		            			if(data.medioscondiciones.length>0){
                                    data.medioscondiciones.sort(function(a, b) {
                                        return (a.orden || 0) - (b.orden || 0);
                                    });
                                    for(var cont=0;cont<data.medioscondiciones.length;cont++){
                                        medioscondiciones.push({medio:data.medioscondiciones[cont].medios_id,medio_data:{condicion:data.medioscondiciones[cont].condiciones_id, tipo_cultivo: ""}, aislados:[]});
			            			}
		            			}
                                scope.data.bloques_medios_condiciones.push({medioscondiciones:medioscondiciones});
                                console.log(scope.data);
				            });
                        }

                        scope.getNextAntibiogramaMalditofID = function(){
                            console.log("getting next antibiograma malditof ID", scope.peticionid, scope.analiticaid);
                            MicrobiologiaService.getNextAntibiogramaMalditofID(scope.peticionid, scope.analiticaid, function(data){
                                console.log("NEXT ID:", data);
                                if(data.next_id>0){
                                    scope.contNextAntibiogramaMalditofID = data.next_id;
                                }
                            });
                        }

                        scope.initMediosResiembra = function(){
                            var medioscondiciones = [];
                            if(scope.medios.length>0){
                                for(var cont=0;cont<scope.medios.length;cont++){
                                    medioscondiciones.push({medio:scope.medios[cont].id,medio_data:{condicion:"", tipo_cultivo: ""}, aislados:[]});
                                }
                            }
                            scope.data.bloques_medios_condiciones.push({medioscondiciones:medioscondiciones});
                        }
                        
                        scope.initLecturaEditable = function(){
                            console.log("EDITANDO LA LECTURA", scope.editarlec);

                            scope.editarlec.bloques.forEach(function(bloque){
                                var medioscondiciones = [];
                                bloque.medios.forEach(function(medio){
                                    var aislados = [];
                                    if(!medio.negativo){
                                        medio.aislados.forEach(function(aislado){
                                            var morfologiaIds = aislado.morfologia && aislado.morfologia.descripcion_ids 
                                                ? aislado.morfologia.descripcion_ids.map(function(desc) {
                                                    return desc.id;
                                                }) 
                                                : [];
                                            var opcionesAisladoIds = aislado.aislado_data && aislado.aislado_data.opciones_aislado 
                                                ? aislado.aislado_data.opciones_aislado.map(function(opc_ais) {
                                                    return opc_ais.id;
                                                }) 
                                                : [];
                                            var mediosresIds = aislado.medios_resiembra 
                                                ? aislado.medios_resiembra.map(function(desc) {
                                                    return desc.id;
                                                })
                                                : [];
                                            var antibiogramaData = {maquina: true};
                                            if (aislado.antibiograma_data) {
                                                antibiogramaData = {
                                                    maquina: aislado.antibiograma_data.maquina,
                                                    manual: aislado.antibiograma_data.manual,
                                                    gp: aislado.antibiograma_data.gp,
                                                    gn: aislado.antibiograma_data.gn,
                                                    ul: aislado.antibiograma_data.ul,
                                                    last_update: aislado.antibiograma_data.last_update,
                                                };
                                                var opcionesAnti = aislado.antibiograma_data.antibiograma_option 
                                                ? aislado.antibiograma_data.antibiograma_option.map(function(opt) {
                                                    return opt.id;
                                                })
                                                : [];
                                                antibiogramaData.antibiograma_option = opcionesAnti;
                                            }
                                            var malditofData = {hongo_fil: false};
                                            if(aislado.malditof_data){
                                                malditofData = {
                                                    hongo_fil: aislado.malditof_data.hongo_fil,
                                                    last_update: aislado.malditof_data.last_update,
                                                }
                                            }
                                            console.log("AISLADO DATA", aislado.aislado_data);
                                            aislados.push({
                                                id: aislado.id,
                                                microorganismo_id: aislado.micro_id, 
                                                morfologia: morfologiaIds,
                                                aislado_data: aislado.aislado_data ? {cantidad: aislado.aislado_data.cantidad ? aislado.aislado_data.cantidad.id : null, valor_cantidad: aislado.aislado_data.valor_cantidad ? aislado.aislado_data.valor_cantidad : null, opciones_aislado: opcionesAisladoIds, observaciones: aislado.aislado_data.observaciones ? aislado.aislado_data.observaciones : null} : null, 
                                                antibiograma: aislado.antibiograma_name ? true : false, 
                                                antibiograma_id: aislado.antibiograma_name ? aislado.antibiograma_name : "",
                                                antibiograma_id_original: aislado.antibiograma_name ? aislado.antibiograma_name : "",
                                                original_aislado: true, 
                                                antibiograma_data: antibiogramaData, 
                                                malditof: aislado.malditof_name ? true : false,
                                                malditof_data: malditofData, 
                                                malditof_id: aislado.malditof_name ? aislado.malditof_name : "",
                                                malditof_id_original: aislado.malditof_name ? aislado.malditof_name : "",
                                                resiembra: aislado.medios_resiembra && aislado.medios_resiembra.length > 0 ? true : false, 
                                                medios_resiembra: mediosresIds
                                            });
                                        });
                                    }
                                    let item = {
                                        medio: medio.medio_id,
                                        medio_data: {condicion: medio.condicion ? medio.condicion.id : null, tipo_cultivo: medio.tipo_cultivo ? medio.tipo_cultivo.id : null, turbidez: medio.turbidez, tio_resiembra: medio.tio_resiembra, tio_reincubacion: medio.tio_reincubacion, negativo: medio.negativo, observaciones: medio.observaciones}, 
                                        aislados: aislados
                                    }

                                    if(angular.isDefined(medio.resiembra_medio) && medio.resiembra_medio){
                                        item.lecturas_resiembra = medio.lecturas_resiembra;
                                        item.medios_resiembra = medio.medios_resiembra;
                                        item.resiembra_data = angular.isDefined(medio.resiembra_data) ? medio.resiembra_data : null;
                                        item.estado_resiembra = medio.estado_resiembra;
                                    }
                                    if(aislados.length<=0){
                                        item.id = medio.id;
                                    }
                                    medioscondiciones.push(item);
                                });
                                scope.data.bloques_medios_condiciones.push({medioscondiciones: medioscondiciones});
                            });
                        }

                        scope.initMediosCond = function(){
                            scope.data.bloques_medios_condiciones = [];
                            scope.getNextAntibiogramaMalditofID();
                            if(scope.editarlec){
                                scope.initLecturaEditable();
                            }else{
                                if(scope.resembradoid>0){
                                    scope.initMediosResiembra();
                                }else{
                                    scope.newMedioCond();
                                }
                            }
                        }
                        scope.initMediosCond();

                        scope.checkNegativo = function(bloqueIndex, medcondIndex){
                            if(scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].medio_data.negativo){
                                scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados = [];
                            }
                        }

                        scope.nuevoMedio = function(bloqueIndex){
	                		scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones.push({medio:"",medio_data:{condicion:"", tipo_cultivo: ""}, aislados:[]});

                            $timeout(function(){
                                var medioIndex = scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones.length - 1;
                                var medioId = 'medio_' + bloqueIndex + '_' + medioIndex;
                                
                                $timeout(function() {
                                    var modalBody = $('.modal-body');
                                    var nuevoBloque = $("#"+medioId);
                                    
                                    if (modalBody && nuevoBloque) {
                                        var topPos = nuevoBloque.offset().top - modalBody.offset().top + modalBody.scrollTop();

                                        console.log(topPos);
                                        modalBody.animate({
                                            scrollTop: topPos
                                          }, 500);
                                    }
                                }, 0);
                            });
	                	}

                        scope.borrarMedioCond =function(bloqueIndex, medcondIndex){
	                		scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones.splice(medcondIndex,1);
                            scope.generarAntibiogramasMalditofIDs();
	                	}

                        scope.duplicarBloque = function(bloque){
                            var newBloque = angular.copy(bloque);
                            newBloque.duplicado = true;
                            scope.data.bloques_medios_condiciones.push(newBloque);
                            console.log("BLOQUES DESPUES DE DUPLICAR", scope.data.bloques_medios_condiciones);
                            scope.generarAntibiogramasMalditofIDs();
                            
                            $timeout(function(){
                                var bloqueIndex = scope.data.bloques_medios_condiciones.length - 1;
                                var bloqueId = 'bloque' + bloqueIndex;
                                
                                $timeout(function() {
                                    var modalBody = $('.modal-body');
                                    var nuevoBloque = $("#"+bloqueId);
                                    
                                    if (modalBody && nuevoBloque) {
                                        var topPos = nuevoBloque.offset().top - modalBody.offset().top + modalBody.scrollTop();

                                        console.log(topPos);
                                        modalBody.animate({
                                            scrollTop: topPos
                                          }, 500);
                                    }
                                }, 0);
                            });
                        }

                        scope.borrarBloque =function(bloqueIndex){
	                		scope.data.bloques_medios_condiciones.splice(bloqueIndex, 1);
                            scope.generarAntibiogramasMalditofIDs();
	                	}

                        scope.addAislado = function(bloqueIndex, medcondIndex){
                            var microorganismo_id = scope.microaislado ? scope.microaislado : 0;
                            scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados.push({microorganismo_id:microorganismo_id, antibiograma: false, antibiograma_data: {maquina: true, manual: false, gp: false, gn: false, ul: false}, malditof: false, malditof_data: {hongo_fil: false}, resiembra: false});

                            $timeout(function(){
                                var aisladoIndex = scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados.length - 1;
                                var aisladoId = 'aislado_' + bloqueIndex + '_' + medcondIndex + '_' + aisladoIndex;
                                
                                $timeout(function() {
                                    var modalBody = $('.modal-body');
                                    var nuevoBloque = $("#"+aisladoId);
                                    
                                    if (modalBody && nuevoBloque) {
                                        var topPos = nuevoBloque.offset().top - modalBody.offset().top + modalBody.scrollTop();

                                        console.log(topPos);
                                        modalBody.animate({
                                            scrollTop: topPos
                                          }, 500);
                                    }
                                }, 0);
                            });
                        }

                        scope.borrarAislado = function(bloqueIndex, medcondIndex, aisladoIndex){
                            scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados.splice(aisladoIndex, 1);
                            scope.generarAntibiogramasMalditofIDs();
                        }

                        scope.borrarResiembra = function(bloqueIndex, medcondIndex, aisladoIndex){
                            scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados[aisladoIndex].resiembra = false;
                            delete scope.data.bloques_medios_condiciones[bloqueIndex].medioscondiciones[medcondIndex].aislados[aisladoIndex].medios_resiembra;
                        }

                        scope.generarAntibiogramasMalditofIDs = function(){
                            var cont = scope.contNextAntibiogramaMalditofID;
                            console.log("cont al iniciar la generacion de tareas IDs", cont);
                            scope.data.bloques_medios_condiciones.forEach(bloque => {
                                bloque.medioscondiciones.forEach(medio => {
                                    medio.aislados.forEach(aislado => {
                                        var existe_tarea = false;
                                        if(aislado.antibiograma){
                                            if(angular.isUndefined(aislado.original_aislado) || !aislado.original_aislado || (angular.isDefined(aislado.antibiograma_id_original) && aislado.antibiograma_id_original == "")){
                                                console.log("AISLADO ANTIBIOGRAMA", aislado);
                                                if((angular.isDefined(aislado.antibiograma_data.maquina) && aislado.antibiograma_data.maquina) && (angular.isDefined(aislado.antibiograma_data.manual) && aislado.antibiograma_data.manual)){
                                                    aislado.antibiograma_id = "S-MAN"+cont;
                                                }else if(angular.isDefined(aislado.antibiograma_data.manual) && aislado.antibiograma_data.manual){
                                                    aislado.antibiograma_id = "MAN"+cont;
                                                }else{
                                                    aislado.antibiograma_id = "S"+cont;
                                                }
                                                existe_tarea = true;
                                            } else{
                                                aislado.antibiograma_id = aislado.antibiograma_id_original;
                                            }
                                        }else{
                                            aislado.antibiograma_id = "";
                                        }

                                        if(aislado.malditof){
                                            if(angular.isUndefined(aislado.original_aislado) || !aislado.original_aislado || (angular.isDefined(aislado.malditof_id_original) && aislado.malditof_id_original == "")){
                                                aislado.malditof_id = "MT"+cont;
                                                existe_tarea = true;
                                            }else{
                                                aislado.malditof_id = aislado.malditof_id_original;
                                            }
                                        }else{
                                            aislado.malditof_id = "";
                                        }

                                        if(existe_tarea){
                                            cont++;
                                        }
                                    });
                                });
                            });
                            console.log("scope.data", scope.data);
                        }

                        scope.guardarLecturaEditada = function(){
                            var resembrado_id = scope.lc.lc.resembrado_id ? scope.lc.lc.resembrado_id : 0;
                            console.log("guardando lectura editada", scope.peticionid, scope.analiticaid, resembrado_id, scope.editarlec.lectura_id, scope.data);
                            console.log("resembradoid", resembrado_id);
                            MicrobiologiaService.guardarLecturaEditada(scope.peticionid, scope.analiticaid, resembrado_id, scope.editarlec.lectura_id, scope.data, function(data){
                                console.log("return guardar lectura editada", data);
                                if(data.errors.length<=0){
                                    scope.generalLab.lecturas = data.lecturas;
                                    scope.lc.modal.close();
                                    scope.getNextAntibiogramaMalditofID();
                                }
                                scope.lc.lc.lecturas[scope.peticionid][scope.analiticaid].count = data.lecturasCount;
                            });
                        }

                        scope.guardarLecturaNew = function(){
                            console.log("guardando lectura", scope.peticionid, scope.analiticaid, scope.data, scope.resembradoid);
                            if(!scope.resembradoid){
                                scope.resembradoid = 0;
                            }
                            MicrobiologiaService.guardarLectura(scope.peticionid, scope.analiticaid, scope.resembradoid, scope.data, function(data){
                                console.log("data return guardar lectura", data);
                                if(data.errors.length<=0){
                                    scope.generalLab.lecturas = data.lecturas;
                                    var collapseElement = document.getElementById('collapseNuevaLectura');
                                    var collapse = bootstrap.Collapse.getInstance(collapseElement);
                                    if (!collapse) {
                                      collapse = new bootstrap.Collapse(collapseElement, { toggle: false });
                                    }
                                    collapse.toggle();
                                    scope.isNuevaLecturaOpen = false;
                                    scope.initMediosCond();
                                }else{
                                    console.error("Error al guardar lectura");
                                }
                                scope.lc.lecturas[scope.peticionid][scope.analiticaid].count = data.lecturasCount;
                            });
                        }

                        scope.guardarLectura = function(){
                            if(scope.editarlec){
                                scope.guardarLecturaEditada();
                            }else{
                                scope.guardarLecturaNew();
                            }
                        }

                        function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

                        scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

                        scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

			        });	
		        }
            }
        }
})();